import { useEffect, useState } from 'react';
import { useAppDispatch } from 'app/store';
import { setHeaderTitle } from 'features/ui/model/uiSlice';
import { useGetActivityTypesQuery } from 'features/getActivityTypes/api/getActivityTypesApi';
import { useNavigate } from 'react-router-dom';
import { useGetActivitiesQuery } from 'features/getActivities/api/getActivitiesApi';
import { Drawer } from 'shared/ui/Drawer/DrawerPromo';
import { CreatePromoCard } from 'entities/promo';
import { fieldPromoB2BConfig } from 'widgets/promoB2B/model/promoB2BTablesColumnConfig';
import { DataTableBackendPagination } from 'shared/ui/Table';
import { useDefaultPromoB2BTableValues } from 'widgets/promoB2B/lib';
import { SelectFilter } from 'shared/ui/Filter/ui/SelectFilter';
import { FilterColumn } from 'shared/ui/Filter';
import { colummConfig } from 'widgets/bonusesStatistics/model';
import debounce from 'lodash.debounce';

type FilterPromoB2BType = {
  app_type: string;
  search: string;
  activity_type_ids: number[];
};

export const PromoB2BWidget = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setHeaderTitle('B2B'));
  }, [dispatch]);

  const [fieldVisibility, setFieldVisibility] = useState(colummConfig.map(() => true));
  const [filterPromoB2B, setFilterPromoB2B] = useState<FilterPromoB2BType>({
    app_type: 'admin',
    search: '',
    activity_type_ids: [],
  });
  const [pagination, setPagination] = useState({
    rowsPerPage: 5,
    page: 0,
  });

  const { data: activitiesList } = useGetActivitiesQuery({
    page: pagination.page + 1,
    size: pagination.rowsPerPage,
    ...filterPromoB2B,
  });
  const { data: activityTypesList } = useGetActivityTypesQuery(null);

  const filterField = fieldPromoB2BConfig.filter((column, index) => fieldVisibility[index]);

  const selectFilterActivitiesTypeOptions =
    activityTypesList?.items.map((type) => ({
      label: type.id,
      value: type.name,
    })) || [];

  const tableData = useDefaultPromoB2BTableValues(activitiesList?.items || []);

  const handlePromoSelect = (id: string | number) => {
    navigate(`/promo/b2b/${id}`);
  };

  const handleSelectChange = (value: string | number[]) => {
    setFilterPromoB2B({ ...filterPromoB2B, activity_type_ids: value as number[] });
  };

  const onSearch = debounce((search) => {
    setFilterPromoB2B({ ...filterPromoB2B, search });
    setPagination({ ...pagination, page: 0 });
  }, 300);

  return (
    <>
      <div
        style={{
          display: 'flex',
          marginBottom: '10px',
          flexDirection: 'row',
          flexWrap: 'wrap',
          gridGap: '10px',
        }}
      >
        <SelectFilter
          multiple
          data={selectFilterActivitiesTypeOptions}
          label="Тип акции"
          onChange={handleSelectChange}
          style={{ marginTop: '8px', width: '25%' }}
        />
      </div>
      <FilterColumn
        columnConfig={fieldPromoB2BConfig}
        fieldVisibility={fieldVisibility}
        setFieldVisibility={setFieldVisibility}
        style={{ marginBottom: '10px', justifyContent: 'flex-end' }}
      />
      <DataTableBackendPagination
        columnConfig={filterField}
        title="Промо-акции для пользователей B2B"
        data={tableData}
        search
        searchPlaceholder="Поиск по наименованию промо-акции"
        onSearch={onSearch}
        onRowClick={(id) => handlePromoSelect(id)}
        total={activitiesList?.total || 0}
        pagination={pagination}
        setPagination={setPagination}
      />
      <Drawer title="Создать  акцию">
        <CreatePromoCard />
      </Drawer>
    </>
  );
};
